import { render, staticRenderFns } from "./TableCouponCatalog.vue?vue&type=template&id=3dc94e19&"
import script from "./TableCouponCatalog.vue?vue&type=script&lang=js&"
export * from "./TableCouponCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports